<template>
  <div>
    <table class="table md-table-global-sales">
      <tbody>
        <tr v-for="item in users" :key="item.country">
          <td>
            <div class="flag">
              <img :src="item.flag" />
            </div>
          </td>
          <td>{{ item.country }}</td>
          <td>{{ item.sales }}</td>
          <td>{{ item.percent }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "global-sales-table",
  data() {
    return {
      selected: [],
      users: [
        {
          flag: "/img/flags/US.png",
          country: "USA",
          sales: "2.920",
          percent: "53.23%",
        },
        {
          flag: "/img/flags/DE.png",
          country: "Germany",
          sales: "1.300",
          percent: "20.43%",
        },
        {
          flag: "/img/flags/AU.png",
          country: "Australia",
          sales: "760",
          percent: "10.35%",
        },
        {
          flag: "/img/flags/GB.png",
          country: "United Kingdom",
          sales: "690",
          percent: "7.87%",
        },
        {
          flag: "/img/flags/RO.png",
          country: "Romania",
          sales: "600",
          percent: "5.94%",
        },
        {
          flag: "/img/flags/BR.png",
          country: "Brasil",
          sales: "550",
          percent: "4.34%",
        },
      ],
    };
  },
};
</script>
